export const validateInventoryForm = (formData, tabType) => {
  const errors = {};

  // 1. Unified Code Validation based on Tab Type
  const codeField = {
    vendor: 'vendorCode',
    brand: 'brandCode',
    category: 'categoryCode',
    subCategory: 'subCategoryCode',
    stores: 'storeCode',
    unit: 'unitCode',
    registeredType: 'registeredTypeCode',
    item: 'itemCode'
  }[tabType] || 'code';

  const codeValue = (formData[codeField] || "").trim();
  if (codeValue && codeValue.length > 20) {
    errors[codeField] = "Code should not exceed 20 characters";
  }

  if (tabType === "vendor") {
    const vendorName = (formData.vendorName || "").trim();
    const mobile = (formData.mobile || "").trim();
    const addressLine1 = (formData.addressLine1 || "").trim();
    const email = (formData.email || "").trim();
    const gstNo = (formData.gstNo || "").trim().toUpperCase();
    const ifscCode = (formData.ifscCode || "").trim().toUpperCase();
    const accountNumber = (formData.accountNumber || "").trim();

    if (!vendorName || vendorName.length < 2) errors.vendorName = "Vendor Name is required (min 2 chars)";
    if (!mobile || !/^\d{10}$/.test(mobile.replace(/\D/g, ''))) errors.mobile = "Valid 10-digit mobile number required (e.g. 9876543210)";
    if (!addressLine1 || addressLine1.length < 5) errors.addressLine1 = "Full address is required (min 5 chars)";
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "Invalid email format (e.g. example@domain.com)";
    if (!formData.state) errors.state = "Please select a State";
    if (!formData.city) errors.city = "City is required";
    if (!formData.pincode || !/^\d{6}$/.test(formData.pincode)) errors.pincode = "Valid 6-digit pincode required (e.g. 110001)";
    // GST type is now optional as requested
    if (gstNo && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstNo)) {
      errors.gstNo = "Invalid GST format. Expected: 22AAAAA0000A1Z5";
    }
    if (ifscCode && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifscCode)) {
      errors.ifscCode = "Invalid IFSC format. Expected: ABCD0123456 (4 letters, zero, 6 alphanumeric)";
    }
    if (accountNumber && !/^\d{9,18}$/.test(accountNumber)) {
      errors.accountNumber = "Invalid account number. Expected 9 to 18 digits.";
    }
  } else if (tabType === "item") {
    if (!formData.itemType) errors.itemType = "Item type is required (e.g. Product)";
    if (!formData.category) errors.category = "Please select a Category";
    if (!formData.brand) errors.brand = "Please select a Brand";
    if (!formData.itemName || formData.itemName.trim().length < 2) errors.itemName = "Item name is required (min 2 chars)";
    if (!formData.itemCode || formData.itemCode.trim().length === 0) errors.itemCode = "Unique Item Code is required";
    if (!formData.units) errors.units = "Unit of measure is required";
    if (formData.isUnique && !formData.uniqueName) errors.uniqueName = "Unique ID name required (e.g. Serial No)";
  } else if (tabType === "brand") {
    const brandName = (formData.brandName || "").trim();
    if (!brandName || brandName.length < 2) errors.brandName = "Brand Name is required";
  } else if (tabType === "category") {
    const categoryName = (formData.categoryName || "").trim();
    if (!categoryName || categoryName.length < 2) errors.categoryName = "Category Name is required";
  } else if (tabType === "subCategory") {
    const subCategoryName = (formData.subCategoryName || "").trim();
    if (!subCategoryName || subCategoryName.length < 2) errors.subCategoryName = "Sub Category Name is required";
  } else if (tabType === "stores") {
    if (!formData.storeName || formData.storeName.trim().length < 2) errors.storeName = "Store name required";
    if (!formData.addressLine1 || formData.addressLine1.trim().length < 5) errors.addressLine1 = "Address is required";
    if (!formData.state) errors.state = "State is required";
    if (!formData.city) errors.city = "City is required";
    if (!formData.pincode || !/^\d{6}$/.test(formData.pincode)) errors.pincode = "Valid 6-digit pincode required";
  } else if (tabType === "unit") {
    const unitName = (formData.unitName || "").trim();
    if (!unitName || unitName.length < 1) errors.unitName = "Unit Name is required";
  } else if (tabType === "registeredType") {
    const registeredTypeName = (formData.registeredTypeName || "").trim();
    if (!registeredTypeName || registeredTypeName.length < 2) errors.registeredTypeName = "Type Name is required";
  } else {
    if (!formData.title || formData.title.trim().length < 2) errors.title = "Title is required";
  }

  return errors;
};
